<h1 mat-dialog-title>Registro de Notificación</h1>
<div mat-dialog-content>
  <form [formGroup]="notificationForm">
    <div fxLayout="row wrap">
      <div class="p-10" fxFlex="100">
        <h3 class="section-title">Destinatarios</h3>
        <mat-radio-group formControlName="recipientType" class="recipient-radio-group">
          <mat-radio-button value="all">Todos los usuarios</mat-radio-button>
          <mat-radio-button value="specific">Usuario específico</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="p-10" fxFlex="100">
        <app-user-autocomplete
          formControlName="selectedUsers"
          placeholder="Ingresa números de teléfono separados"
        ></app-user-autocomplete>
      </div>

      <div class="p-10" fxFlex="100">
        <h3 class="section-title">Título de la Notificación</h3>
        <mat-form-field>
          <input
            matInput
            formControlName="title"
            placeholder="Ej: ¡Subasta #004 Finalizando!"
          />
          <mat-hint
            *ngIf="notificationForm.get('title').hasError('required') && notificationForm.get('title').touched"
            class="text-danger font-14"
          >
            El título es obligatorio
          </mat-hint>
        </mat-form-field>
      </div>

      <div class="p-10" fxFlex="100">
        <h3 class="section-title">Mensaje</h3>
        <mat-form-field>
          <textarea
            matInput
            formControlName="description"
            placeholder="Escriba aquí el contenido de su notificación..."
            rows="5"
          ></textarea>
          <mat-hint
            *ngIf="notificationForm.get('description').hasError('required') && notificationForm.get('description').touched"
            class="text-danger font-14"
          >
            El mensaje es obligatorio
          </mat-hint>
        </mat-form-field>
      </div>
    </div>
  </form>
</div>
<div mat-dialog-actions>
  <div class="m-r-5">
    <button
      mat-raised-button
      color="accent"
      (click)="onCancel()"
      [disabled]="sendNotificationLoader.isRunning"
      tabindex="2"
    >
      Cancelar
    </button>
    <div class="m-t-10"></div>
  </div>
  <app-action-loader #sendNotificationLoader>
    <button
      mat-raised-button
      color="primary"
      (click)="onSend()"
      tabindex="1"
      type="submit"
      [disabled]="!isFormValid || sendNotificationLoader.isRunning"
    >
      Enviar Notificación
    </button>
  </app-action-loader>
</div>

